import React from "react";
import { ReactTitle } from "react-meta-tags";

const styles = {
  height: "100vh",
  width: "100%",
};
const headstyles = {
  width: "max-content",
  height: "max-content",
  borderRadius: "2em",
  background: "#011a27",
  color: "yellow",
  marginTop: "3em",
};

const ComingSoon = () => {
  return (
    <div
      id="comingsoon"
      className="comingsoon d-flex justify-content-center pt-4"
      style={styles}
    >
      <ReactTitle title="Vibgyor Advisors - Real Estate" />
      <h1
        className=" py-2 px-3 text-uppercase border border-2 border-danger  "
        style={headstyles}
      >
        Coming Soon
      </h1>
    </div>
  );
};

export default ComingSoon;
